import React from 'react'

const Footer = () => (
  <div
    className="stellar"
    dangerouslySetInnerHTML={{__html: footerString}}
  >
  </div>
)

export default Footer

const footerString = `
<footer class="footer">
    <!-- Top Section -->
   <div class="footer__section footer__section--top">
       <div class="footer__message">
    <span class="footer__message-title-thin">Join Our</span>
    <span class="footer__message-title-bold">Newsletter</span>
</div>
<div class="footer__message-description">Sign up for our monthly newsletter and special deals.</div>
       <form class="form footer__form" action="/subscribe.php" method="post">
        <fieldset class="form-fieldset">
                <input type="hidden" name="action" value="subscribe">
                <input type="hidden" name="nl_first_name" value="bc">
                <input type="hidden" name="check" value="1">
                <div class="form-field">
                <label class="form-label is-srOnly" for="nl_email">Email Address</label>
                <div class="form-prefixPostfix wrap">
                        <a href="https://eepurl.com/bEzq91" target="_blank" rel="noopener" class="footer__input footer__input--submit">Subscribe</a>
                </div>
                </div>
        </fieldset>
</form>

   </div>
   <!-- Middle Section -->
   <div class="footer__section footer__section--mid">
        <div class="footer__nav">
        <div class="footer__nav-component">
            <h3 class="footer__nav-title">Further Info</h3>
            <ul class="footer__list">
            <li class="footer__list-item">
    <a class="footer__link footer__link--alt" href="/about-us/">About Us</a>
</li>
<li class="footer__list-item">
    <a class="footer__link footer__link--alt" href="/faqs/">FAQs</a>
</li>
<li class="footer__list-item">
    <a class="footer__link footer__link--alt" href="/contact-us/">Contact Us</a>
</li>
<li class="footer__list-item">
    <a class="footer__link footer__link--alt" href="/loyalty-rewards/">Loyalty Rewards</a>
</li>
<li class="footer__list-item">
    <a class="footer__link footer__link--alt" href="/privacy-policy/">Privacy Policy</a>
</li>
<li class="footer__list-item">
    <a class="footer__link footer__link--alt" href="/ordering-shipping-returns/">Ordering/Shipping/Returns</a>
</li>
<li class="footer__list-item">
    <a class="footer__link footer__link--alt" href="/blog/">News &amp; Updates</a>
</li>
        </ul>
        </div>
        <div class="footer__nav-component">
            <h3 class="footer__nav-title">Follow Us For Updates</h3>
            <div class="footer__social">
    <ul class="footer__list footer__list--social">
            <li class="footer__list-item footer__list-item--social">
                <a class="footer__link footer__link--alt" href="https://www.youtube.com/channel/UCs-5AlzI0UhpAcI4aRA0sRQ">
                    <span class="icon icon--social icon--social-youtube">
                        <svg><use class="footer__icon--social" xlink:href="#icon-stellaryoutube"></use></svg>
                    </span>

                </a>
            </li>
            <li class="footer__list-item footer__list-item--social">
                <a class="footer__link footer__link--alt" href="https://www.instagram.com/stellarscientific/">
                    <span class="icon icon--social icon--social-instagram">
                        <svg><use class="footer__icon--social" xlink:href="#icon-stellarinstagram"></use></svg>
                    </span>

                </a>
            </li>
            <li class="footer__list-item footer__list-item--social">
                <a class="footer__link footer__link--alt" href="https://www.linkedin.com/company/stellar-scientific?trk=nav_account_sub_nav_company_admin">
                    <span class="icon icon--social icon--social-linkedin">
                        <svg><use class="footer__icon--social" xlink:href="#icon-stellarlinkedin"></use></svg>
                    </span>

                </a>
            </li>
            <li class="footer__list-item footer__list-item--social">
                <a class="footer__link footer__link--alt" href="https://www.facebook.com/pages/Stellar-Scientific/539238369530285?ref=hl">
                    <span class="icon icon--social icon--social-facebook">
                        <svg><use class="footer__icon--social" xlink:href="https://stellarscientific.com/icon-stellarfacebook"></use></svg>
                    </span>

                </a>
            </li>
    </ul>
</div>
            <div class="footer__nav-images">
                <img class="footer__nav-images-logos" src="https://verify.authorize.net/anetseal/images/secure90x72.gif">
                <div class="footer__nav-images-logos"><table width="135" border="0" cellpadding="2" cellspacing="0" title="Click to Verify - This site chose GeoTrust SSL for secure e-commerce and confidential communications.">
                        <tbody><tr>
                        <td width="135" align="center" valign="middle"><script type="text/javascript" src="https://seal.geotrust.com/getgeotrustsslseal?host_name=www.stellarscientific.com&amp;size=M&amp;lang=en"></script><a href="https://sealsplash.geotrust.com/splash?&amp;dn=www.stellarscientific.com" tabindex="-1" onmousedown="return gts_mDown(event);" target="GEOTRUST_SSL_Splash"><img name="gts_seal" border="true" src="https://seal.geotrust.com/getgeotrustsslseal?at=0&amp;sealid=1&amp;dn=www.stellarscientific.com&amp;lang=en&amp;gmtoff=0" oncontextmenu="return false;" alt="Click to Verify - This site has chosen a GeoTrust SSL Certificate to improve Web site security"></a><br>
                        <a href="https://www.geotrust.com/ssl/" target="_blank" style="color:#000000; text-decoration:none; font:bold 7px verdana,sans-serif; letter-spacing:.5px; text-align:center; margin:0px; padding:10px;"></a></td>
                        </tr>
                </tbody></table>
                </div>
            </div>

        </div>
</div>
        <div class="footer__image-wrapper">
    <img class="cta__img footer__image ls-is-cached lazyloaded" src="https://cdn11.bigcommerce.com/s-w9bdixgj/stencil/a3223610-b328-0138-3ffb-0242ac11000f/e/2ce3e870-1871-0138-3077-0242ac11000e/img/stellarscientific_logo.svg" alt="Stellar Scientific">

  </div>

   </div>
   <!-- Bottom Section -->
   <div class="footer__section footer__section--bottom">
      <p class="footer__text">© 2019 <span style="font-weight: bold;">Stellar Scientific</span> | <a class="footer__link footer__link--white" href="/sitemap/">Sitemap</a> | <a class="footer__link footer__link--white" href="/privacy-policy/">Privacy Policy</a> | Design &amp; Development by <a href="https://www.intuitsolutions.net/" class="footer__its">IntuitSolutions</a></p>
<!-- IntuitSolutions.net - Quick Reorder -->
    <div class="qrb__cart-data">

</div>
   </div>
</footer>
`
